import React, { Dispatch, SetStateAction, useState } from 'react';
import { PopupOrPanel } from '../../../components/popupsAndPanels/PopupAndPanels';
import { Spinner } from 'components/spinner/Spinner';
import { WondeApi } from 'api/wondeApi';
import WarningIcon from 'images/Icon_Warning_01.png';
import { useToast } from 'hooks/useToast';
import { SyncDataOption } from '../WondeIntegration';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  recordsSelected: any;
  setWondeIntegration: Dispatch<SetStateAction<boolean>>;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  syncDataOpts: SyncDataOption[];
  setSyncDataOpts: Dispatch<SetStateAction<SyncDataOption[]>>;
  submitUrl: string;
  currentSynOpt: string;
  tableData: any;
};

export const DeleteRecordsPopup: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  recordsSelected,
  setWondeIntegration,
  setCurrentStep,
  syncDataOpts,
  setSyncDataOpts,
  submitUrl,
  currentSynOpt,
  tableData,
}) => {
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [recordsDeleted, setRecordsDeleted] = useState<boolean>(false);

  const successToast = useToast("Successfully submitted");

  const handleDataSyncNextStep = () => {
    const updatedSyncDataOpts = syncDataOpts.slice(1);

    window.scrollTo(0, 0);
    togglePanelOpen(false);          

    if(updatedSyncDataOpts.length > 0){            
      setSyncDataOpts(updatedSyncDataOpts);
      setCurrentStep(1);
    } else {
      setWondeIntegration(false);
    }
  };  

  // Ends the first sync after an MIS change; the API ignores it on a normal sync
  const completePupilStep = async () => {
    setIsSubmitting(true);

    const result = await WondeApi.completeMisChangeSync();

    if (result.error) {
      setError("An error occurred, please try again.");
      setIsSubmitting(false);
      return;
    }

    handleDataSyncNextStep();
  };

  const finishStep = () => {
    if (currentSynOpt === "Pupil") {
      completePupilStep();
    } else {
      handleDataSyncNextStep();
    }
  };

  const submitRecordOpts = async (selected_items: any) => {
    setIsSubmitting(true);
    
    const selectedIds = currentSynOpt === "Class" ? 
      selected_items.map((item: any) => item.classes__id) :
      currentSynOpt === "Pupil" ?
      selected_items.map((item: any) => item.pupils__id) :
      selected_items.map((item: any) => item.schoolusers__id);

    const result = await WondeApi.deleteRemainingGetSetRecords(selectedIds, submitUrl);

    if (!result.error) {
      successToast();
      setRecordsDeleted(true);
      finishStep();
    }
    
    if (result.error) {
      setError("An error occurred, please try again.");
      setIsSubmitting(false);
    }    
  };

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={"Delete Records"}
      position="right"
      givenClass="WondeDeleteRecords"
      noFooter={false}
      primaryBtnTxt="Confirm"
      secondaryBtnTxt="Cancel"       
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => {
        if(isSubmitting){
          return;
        }

        if(recordsSelected.length > 0 && !recordsDeleted){
          submitRecordOpts(recordsSelected);
        } else {
          finishStep();
        }
      }}      
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={460}
      isSubmitting={isSubmitting}
    >
      {error && <p className="GeneralError2">{error}</p>}

      {(!tableData || tableData.length <= 0) && <p>There are no records to delete in Get Set.</p>}

      {tableData && tableData.length > 0 && recordsSelected.length <= 0 && <p>Are you sure you do not wish to delete any additional records in Get Set?</p>}

      {recordsSelected.length > 0 &&
        <>
          <p>Are you sure you want to permanently delete these records?</p>
          <div className="LineSpacer3"></div>
          <p><strong>You’ll permanently delete all associated data in this academic year for:</strong></p>

          <div className="PopupRecordsList">
            {recordsSelected.map((item: any, index: number) => {
              return (
                <div className="RLItem" key={index}>- {currentSynOpt === "Class" ? 
                item.classes__classname :
                currentSynOpt === "Pupil" ?
                item.pupils__name :
                item.contactdetails__name}</div>
              );
            })}
          </div>

          <div className="Warning RedBack">
            <img src={WarningIcon} alt="Warning" />
            <p>This action cannot be undone</p>
          </div>
        </>
      }

      {isSubmitting && <Spinner color={'#f59e16'} /> }          
    </PopupOrPanel>
  );  
};